'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuthenticationLogin = require('./AuthenticationLogin.scss');

var _AuthenticationLogin2 = _interopRequireDefault(_AuthenticationLogin);

var _ButtonStandard = require('../../managewidgets/components/button/ButtonStandard');

var _ButtonStandard2 = _interopRequireDefault(_ButtonStandard);

var _ButtonLight = require('../../managewidgets/components/button/ButtonLight');

var _ButtonLight2 = _interopRequireDefault(_ButtonLight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticationLogin = function (_Component) {
  (0, _inherits3.default)(AuthenticationLogin, _Component);

  function AuthenticationLogin() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AuthenticationLogin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthenticationLogin.__proto__ || (0, _getPrototypeOf2.default)(AuthenticationLogin)).call.apply(_ref, [this].concat(args))), _this), _this.getLoginUrl = function () {
      return _this.props.site + '?authenticationMode=true&popup=true&origin=' + window.location.origin;
    }, _this.openLoginWindow = function () {
      _this.closeLoginWindow();

      var width = 500;
      var height = 650;

      // open window in center screen
      var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

      var w = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
      var h = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

      var systemZoom = w / window.screen.availWidth;
      var left = (w - width) / 2 / systemZoom + dualScreenLeft;
      var top = (h - height) / 2 / systemZoom + dualScreenTop;

      _this.loginWindow = window.open(_this.getLoginUrl(), '_blank', 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);
    }, _this.closeLoginWindow = function () {
      if (_this.loginWindow) {
        _this.loginWindow.close();
        _this.loginWindow = null;
      }
    }, _this.parseMessage = function (e) {
      if (e.data === null || !e.data.indexOf) {
        return;
      }

      var authData = JSON.parse(e.data);

      if (authData.type === 'authenticated') {
        _this.props.onAuthenticated(authData.memberHash, authData.memberId, authData.companyName);
        _this.closeLoginWindow();
      }
    }, _this.resetSite = function () {
      _this.props.onResetSite();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AuthenticationLogin, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('message', this.parseMessage);
      window.addEventListener('beforeunload', this.closeLoginWindow);
      this.openLoginWindow();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.parseMessage);
      window.removeEventListener('beforeunload', this.closeLoginWindow);
      this.closeLoginWindow();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _AuthenticationLogin2.default.wrap },
        _react2.default.createElement(
          'div',
          null,
          'Attempting to log into:'
        ),
        _react2.default.createElement(
          'div',
          { className: _AuthenticationLogin2.default.site },
          this.props.site
        ),
        _react2.default.createElement(
          'div',
          { className: _AuthenticationLogin2.default.buttons },
          _react2.default.createElement(_ButtonLight2.default, { automationName: 'manage_auth_reset_site', value: 'Reset Site', onClick: this.resetSite }),
          _react2.default.createElement(_ButtonStandard2.default, { className: _AuthenticationLogin2.default.loginBtn, automationName: 'manage_auth_login', value: 'Log into Manage', onClick: this.openLoginWindow })
        )
      );
    }
  }]);
  return AuthenticationLogin;
}(_react.Component);

AuthenticationLogin.propTypes = {
  site: _propTypes2.default.string.isRequired,
  onResetSite: _propTypes2.default.func.isRequired,
  onAuthenticated: _propTypes2.default.func.isRequired
};

exports.default = AuthenticationLogin;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/authentication/AuthenticationLogin.js
// module id = 319
// module chunks = 10